
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top/delivery",
      function () {
        return require("private-next-pages/top/delivery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top/delivery"])
      });
    }
  